// extracted by mini-css-extract-plugin
export default {"component":"thumbableServiceDialog__component___bDblx"};